import gql from "graphql-tag";

import { Fragment, Company } from "../types";

export const COMPANY_MINIMAL_FRAGMENT = gql`
  fragment CompanyMinimalFragment on Company {
    id
    name
    visualIdentity
    theme {
      primary
      secondary
    }
  }
`;

export type CompanyMinimalFragment = Fragment<
  Company,
  Pick<Company, "id" | "name" | "visualIdentity" | "theme">
>;
